<template src="../../templates/form/register-form.pug" lang="pug"></template>

<script>
    import Modal from './Modal.vue'
    import $axios from '../../axios'
    import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

    export default {
        name: "RegisterForm",
        components: {
            Modal
        },
        data() {
            return {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                repeatPassword: '',
            }
        },
        computed: {
            isFormValid() {
                return !this.$v.email.$invalid &&
                    !this.$v.firstname.$invalid &&
                    !this.$v.lastname.$invalid &&
                    !this.$v.password.$invalid
            }
        },
        validations: {
            firstname: {
                required,
                minLength: minLength(2)
            },
            lastname: {
                required,
                minLength: minLength(2)
            },
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        },
        methods: {
            close() {
                this.$parent.showRegisterForm = false
            },
            submit() {
                if (this.isFormValid) {
                    const params = new URLSearchParams()
                    params.append(
                        'fos_user_registration_form[firstname]',
                        this.firstname
                    )
                    params.append('fos_user_registration_form[lastname]', this.lastname)
                    params.append('fos_user_registration_form[email]', this.email)
                    params.append('fos_user_registration_form[username]', this.email)
                    params.append(
                        'fos_user_registration_form[plainPassword][first]',
                        this.password
                    )
                    params.append(
                        'fos_user_registration_form[plainPassword][second]',
                        this.password
                    )
                    let self = this
                    $axios
                        .post(`/register/`, params)
                        .then(response => {
                            this.close()
                        })
                }
            }
        }
    }
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #register-modal
        .modal-container
            .modal-header
                background-color: $dd-moderate-lime-green
                color: white
            .modal-body
                form
                    input, input:focus, input:valid, .multiselect
                        border-left: 8px solid $dd-moderate-lime-green
</style>